import { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import { TermsAccept, TermsDetails } from '@/features/terms-and-conditions/types';

const { axiosService } = useAxios();

export const fetchTermsDetails = async (): Promise<TermsDetails | null> => {
  try {
    const termsRes: AxiosResponse = await axiosService.get('/terms-and-conditions/details');
    return termsRes.data;
  } catch {
    return null;
  }
};

export const acceptTerms = async (): Promise<TermsAccept | null> => {
  try {
    const termsAcceptRes: AxiosResponse = await axiosService.post('/terms-and-conditions/accepted', { accepted: true });
    return termsAcceptRes.data;
  } catch {
    return null;
  }
};

export const remindLater = async (version: number): Promise<boolean> => {
  try {
    const res = await axiosService.post(`/terms-and-conditions/ask-me-later/${version}`);
    return res.data.isTermsAndConditionsAskMeLater;
  } catch {
    return false;
  }
};
